// extracted by mini-css-extract-plugin
export default {"container":"Attribute_container__aDcow"};